import { render, staticRenderFns } from "./transientSave.vue?vue&type=template&id=065169cb&scoped=true&"
import script from "./transientSave.vue?vue&type=script&lang=js&"
export * from "./transientSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065169cb",
  null
  
)

export default component.exports